import { Avatar, Button,Modal,Drawer} from "antd"
import {ExclamationCircleOutlined,MenuOutlined,HomeFilled,ShoppingCartOutlined,UserOutlined,InfoCircleFilled} from "@ant-design/icons/lib/icons"
import { signOut } from "firebase/auth"
import { Link, useNavigate } from "react-router-dom"
import styled from "styled-components"
import { auth } from "../Config"
import { useState } from "react"
import Navbar from './Navbar';
const HeaderField = styled.div`
    height:12vh;
    width:100vw;
    display:flex;
    justify-content:flex-end;
    align-items:center;
    border-bottom:1px solid #ccc;
    position:fixed;
    z-index:1;
    background-color:white;
    .header-logo{
        color: black;
        text-decoration:none;
        font-family:Kaushan Script, cursive;
        font-size:1.5vmax;
        @media (max-width:767px){
            font-size:3vmin;
        }
    }
    .header-btn{
        display:none;
        @media (max-width:767px){
            display:block;
            margin-right:25vw;
            border-radius:10px;
            background-color:white;
            border-color:black;
            color: black;
            margin-left:1vw;
        }
    }
    .user-field{
        padding-left:25vw;
        padding-right:10vw;
        @media (max-width:1023px) and (min-width:768px){
            padding-left:20vw;
        }
        @media (max-width:767px){
            padding-left:10vw;
            padding-right:2vw;
        }
        .avt{

        }
        
        .logout-btn{
            width: 8vw;
            height: 5vh;
            background-color: tomato;
            color: white;
            border-radius: 20px;
            font-size: 1vmax;
            margin-left:1vw;
            :hover{
                border-color: none;
                cursor: pointer;
            }
            :focus{
                border-color: none;
            }
            @media (max-width:1023px) and (min-width:768px){
                width: 12vw; 
                font-size: 1.5vmin;
            }
            @media (max-width:767px){
                width: 18vw;
                font-size: 1.9vmin;
                
            }
        }
    }
`
export default function Header(){
    let navigate =useNavigate()
    const { confirm } = Modal;
    function showDeleteConfirm() {
        confirm({
          title: 'Bạn muốn đăng xuất?',
          icon: <ExclamationCircleOutlined />,
          okText: 'Chắc chắn',
          okType: 'danger',
          cancelText: 'Trở lại',
          onOk() {
            signOut(auth)
            navigate('/')
            console.log('OK');
          },
          onCancel() {
            console.log('Cancel');
          },
        });
    }
    const [visible, setVisible] = useState(false);

    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };
    return(
        <HeaderField>
            <Button className="header-btn" onClick={showDrawer}><MenuOutlined /></Button>
            <Link to='/home'  className='header-logo'><h1 style={{margin:'0'}}>MeStore</h1></Link>
            <div className="user-field">
                <Avatar src={auth.currentUser ? auth.currentUser.photoURL : ''} className='avt'></Avatar>
                <Button className="logout-btn" onClick={showDeleteConfirm}>Đăng Xuất</Button>
            </div>
            <Drawer
                title="Menu"
                placement='left'
                width={200}
                onClose={onClose}
                visible={visible}
            >
                <Link to='/home' style={{color:'black',display:'flex',flexDirection:'column',alignItems:'center',margin:'3vh 0'}} onClick={onClose}><HomeFilled  style={{fontSize:'7vmin',marginBottom:'2vh'}}/><p>Trang chủ</p></Link>
                <Link to='/home/cart' style={{color:'black',display:'flex',flexDirection:'column',alignItems:'center',margin:'3vh 0'}} onClick={onClose}><ShoppingCartOutlined  style={{fontSize:'7vmin',marginBottom:'2vh'}}/><p>Giỏ hàng</p></Link>
                <Link to='/home/user' style={{color:'black',display:'flex',flexDirection:'column',alignItems:'center',margin:'3vh 0'}} onClick={onClose}><UserOutlined   style={{fontSize:'7vmin',marginBottom:'2vh'}}/><p>Thông tin người dùng</p></Link>
            </Drawer>
        </HeaderField>
    )
}